import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { deleteCompany, editCompany, getCompany } from "../Services/ContectService";
import { Context } from "../Context/Context";
import { toast } from "react-toastify";
import swal from "sweetalert";

const LegalInformation = () => {
    const { json, user, setLoading, provinceList } = useContext(Context);
    const [company, setCompany] = useState([]);

    const companyHandler = async () => {
        setLoading(true);
        try {
            const { status, data } = await getCompany(user);
            if (status === 200) {
                setCompany(data.filter(item => !item.is_deleted));
                setLoading(false);
            }
        } catch (error) {
            toast.error(json.toast.err_1);
            setLoading(false);
        }
    }

    const handleChangeDefaultCompany = async (ev, value) => {
        try {
            const { status, data } = await editCompany(user, {
                default_company: true
            }, value.id);
            if (status === 200) {
                setCompany(prevValue => prevValue.map(item => item.id === data.id ? data : {
                    ...item,
                    default_company: false
                }));
            }
        } catch (ex) {
            toast.error(json.toast.err_1);
        }
    }

    const handleDeleteCompany = async (id) => {
        const res = await swal({
            title: "آیا از حذف شرکت مطمئن هستید؟",
            text: "در صورت حذف دیگر امکان برگشت وجود ندارد",
            icon: "warning",
            buttons: {
                cancel: "لغو",
                yes: "تایید"
            },
            dangerMode: true,
        })
        if (!res) return;
        try {
            const { status, data } = await deleteCompany(user, id)
            if (status === 204) {
                setCompany(prevValue => prevValue.filter(item => item.id !== id));
            }
        } catch (error) {
            if (error.response.status === 400) {
                toast.error("شما اجازه حذف شرکت را ندارید");
                return;
            }
            toast.error(json.toast.err_1);
        }
    }

    useEffect(() => {
        companyHandler();
    }, [])

    return (<>
        <div className="lg:w-[65%] w-full">
            <Link to="/account/legal-information/create" className="bg-blue-700 w-52 p-2 rounded-lg flex cursor-pointer">
                <svg width="28" height="28" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 2.5C13.33 2.5 10.7199 3.29176 8.49981 4.77516C6.27974 6.25856 4.54942 8.36697 3.52763 10.8338C2.50585 13.3006 2.2385 16.015 2.7594 18.6337C3.28031 21.2525 4.56606 23.6579 6.45406 25.5459C8.34207 27.434 10.7475 28.7197 13.3663 29.2406C15.985 29.7615 18.6994 29.4942 21.1662 28.4724C23.633 27.4506 25.7414 25.7203 27.2248 23.5002C28.7082 21.2801 29.5 18.67 29.5 16C29.496 12.4208 28.0724 8.98932 25.5416 6.45844C23.0107 3.92756 19.5792 2.50397 16 2.5ZM16 26.5C13.9233 26.5 11.8932 25.8842 10.1665 24.7304C8.4398 23.5767 7.09399 21.9368 6.29927 20.0182C5.50455 18.0996 5.29662 15.9884 5.70176 13.9516C6.10691 11.9148 7.10693 10.0438 8.57538 8.57538C10.0438 7.10693 11.9148 6.1069 13.9516 5.70175C15.9884 5.29661 18.0996 5.50454 20.0182 6.29926C21.9368 7.09399 23.5767 8.4398 24.7304 10.1665C25.8842 11.8932 26.5 13.9233 26.5 16C26.497 18.7839 25.3898 21.4528 23.4213 23.4213C21.4529 25.3898 18.7839 26.497 16 26.5ZM22.5 16C22.5 16.3978 22.342 16.7794 22.0607 17.0607C21.7794 17.342 21.3978 17.5 21 17.5H17.5V21C17.5 21.3978 17.342 21.7794 17.0607 22.0607C16.7794 22.342 16.3978 22.5 16 22.5C15.6022 22.5 15.2206 22.342 14.9393 22.0607C14.658 21.7794 14.5 21.3978 14.5 21V17.5H11C10.6022 17.5 10.2207 17.342 9.93935 17.0607C9.65804 16.7794 9.50001 16.3978 9.50001 16C9.50001 15.6022 9.65804 15.2206 9.93935 14.9393C10.2207 14.658 10.6022 14.5 11 14.5H14.5V11C14.5 10.6022 14.658 10.2206 14.9393 9.93934C15.2206 9.65804 15.6022 9.5 16 9.5C16.3978 9.5 16.7794 9.65804 17.0607 9.93934C17.342 10.2206 17.5 10.6022 17.5 11V14.5H21C21.3978 14.5 21.7794 14.658 22.0607 14.9393C22.342 15.2206 22.5 15.6022 22.5 16Z" fill="white" />
                </svg>
                <p className="text-white mr-3">افزودن شرکت جدید</p>
            </Link>
            {company.map((data, index) => (
                <div key={`companyItem_${index}`} className="mt-4 w-full border border-black rounded-lg p-2 bg-[#F5F5F5]">
                    <div className="w-full flex justify-between">
                        <p>{data.name}</p>
                        <div className="flex flex-col gap-2">
                            <div className="flex justify-center items-center cursor-pointer">
                                <Link to={`/account/legal-information/edit/${data.id}`}>
                                    ویرایش اطلاعات
                                </Link>
                                <svg className="mr-1" width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M28.7675 8.8175L23.1825 3.23125C22.9504 2.99899 22.6747 2.81476 22.3713 2.68906C22.0679 2.56336 21.7428 2.49866 21.4144 2.49866C21.086 2.49866 20.7608 2.56336 20.4574 2.68906C20.1541 2.81476 19.8784 2.99899 19.6463 3.23125L4.23251 18.6462C3.99951 18.8777 3.81479 19.1531 3.68905 19.4566C3.56331 19.76 3.49905 20.0853 3.50001 20.4137V26C3.50001 26.663 3.7634 27.2989 4.23224 27.7678C4.70108 28.2366 5.33697 28.5 6.00001 28.5H11.5863C11.9147 28.5009 12.24 28.4366 12.5434 28.3109C12.8468 28.1851 13.1222 28.0004 13.3538 27.7675L28.7675 12.3525C29.2362 11.8837 29.4995 11.2479 29.4995 10.585C29.4995 9.92209 29.2362 9.28632 28.7675 8.8175ZM11.375 25.5H6.50001V20.625L17 10.125L21.875 15L11.375 25.5ZM24 12.875L19.125 8L21.4175 5.7075L26.2925 10.5825L24 12.875Z" fill="black" />
                                </svg>
                            </div>
                            <div className="flex justify-end items-center cursor-pointer font-bold hover:text-[#0a58ca] transition-all">
                                <span className="mx-2"
                                    onClick={() => handleDeleteCompany(data.id)}
                                >
                                    حذف
                                </span>
                                <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M27 6H22.5V4.5C22.5 3.57174 22.1313 2.6815 21.4749 2.02513C20.8185 1.36875 19.9283 1 19 1H13C12.0717 1 11.1815 1.36875 10.5251 2.02513C9.86875 2.6815 9.5 3.57174 9.5 4.5V6H5C4.60218 6 4.22064 6.15804 3.93934 6.43934C3.65804 6.72064 3.5 7.10218 3.5 7.5C3.5 7.89782 3.65804 8.27936 3.93934 8.56066C4.22064 8.84196 4.60218 9 5 9H5.5V26C5.5 26.663 5.76339 27.2989 6.23223 27.7678C6.70107 28.2366 7.33696 28.5 8 28.5H24C24.663 28.5 25.2989 28.2366 25.7678 27.7678C26.2366 27.2989 26.5 26.663 26.5 26V9H27C27.3978 9 27.7794 8.84196 28.0607 8.56066C28.342 8.27936 28.5 7.89782 28.5 7.5C28.5 7.10218 28.342 6.72064 28.0607 6.43934C27.7794 6.15804 27.3978 6 27 6ZM12.5 4.5C12.5 4.36739 12.5527 4.24021 12.6464 4.14645C12.7402 4.05268 12.8674 4 13 4H19C19.1326 4 19.2598 4.05268 19.3536 4.14645C19.4473 4.24021 19.5 4.36739 19.5 4.5V6H12.5V4.5ZM23.5 25.5H8.5V9H23.5V25.5ZM14.5 13V21C14.5 21.3978 14.342 21.7794 14.0607 22.0607C13.7794 22.342 13.3978 22.5 13 22.5C12.6022 22.5 12.2206 22.342 11.9393 22.0607C11.658 21.7794 11.5 21.3978 11.5 21V13C11.5 12.6022 11.658 12.2206 11.9393 11.9393C12.2206 11.658 12.6022 11.5 13 11.5C13.3978 11.5 13.7794 11.658 14.0607 11.9393C14.342 12.2206 14.5 12.6022 14.5 13ZM20.5 13V21C20.5 21.3978 20.342 21.7794 20.0607 22.0607C19.7794 22.342 19.3978 22.5 19 22.5C18.6022 22.5 18.2206 22.342 17.9393 22.0607C17.658 21.7794 17.5 21.3978 17.5 21V13C17.5 12.6022 17.658 12.2206 17.9393 11.9393C18.2206 11.658 18.6022 11.5 19 11.5C19.3978 11.5 19.7794 11.658 20.0607 11.9393C20.342 12.2206 20.5 12.6022 20.5 13Z" fill="black" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <p className="mt-2 text-gray-400">شناسه ملی: {data.national_id}</p>
                    <div className="w-full flex justify-between">
                        <p className="text-gray-400">
                            آدرس: {`استان ${provinceList.find(p => p.state === data.province)?.name}، شهر ${data.city}، ${data.registration_address}`}
                        </p>
                        <div
                            className={`flex justify-center items-center 
                            ${data.default_company === true ? "" : "cursor-pointer"}`}
                            onClick={data.default_company ? () => { } : (ev) => handleChangeDefaultCompany(ev, data)}
                        >
                            <div className={`border w-4 h-4 rounded-full ${data.default_company === true ? "bg-blue-800" : "bg-slate-400"}`}>
                            </div>
                            <p className="mr-1">شرکت پیش فرض</p>
                        </div>
                    </div>
                </div>
            ))}

        </div>
    </>);
}

export default LegalInformation;